// removed by extract-text-webpack-plugin
module.exports = {"galleryItem":"_2T6hJADGA8c6yj8YEoMStr"};


/*****************
 ** WEBPACK FOOTER
 ** ../components/GalleryItem.module.scss
 ** module id = 1328
 ** module chunks = 0
 **/